export default __webpack_public_path__ + "static/media/mountain_close_up.d4f483cd.jpg";